import React from 'react';
import PropTypes from 'prop-types';
import { createSurveyStyles } from '@sm/webassets';
import './survey-title.scss';

const useStyles = createSurveyStyles(theme => {
  return {
    surveyTitle: {
      ...theme.surveyTitle,
      color: theme.titleColor,
    },
  };
});

const SurveyTitle = ({ title }) => {
  const { surveyTitle } = useStyles();
  return (
    <div className={`sm-survey-title--container ${surveyTitle}`} data-testid="SurveyTitle__Container">
      {title}
    </div>
  );
};

SurveyTitle.propTypes = {
  title: PropTypes.string,
};

SurveyTitle.defaultProps = {
  title: '',
};

export default SurveyTitle;
